module.exports = __webpack_public_path__ + "img/acceptAarrow.1e410ba9.svg";